export const getStatusColorForProgressBar = ({
  accomplished,
  numOfSteps,
  index,
  progress,
  error,
}) => {
  const stepProgress = (100 / (numOfSteps - 1)) * index;
  const progressDelta = stepProgress - progress;
  const inProgress =
    progressDelta > 0 && progressDelta < 100 / (numOfSteps - 1) && !error;
  let backgroundColor, fontColor, borderColor;
  if (accomplished) {
    backgroundColor = '#84cc16';
    fontColor = '#fff';
    borderColor = '#84cc16';
  } else if (inProgress) {
    backgroundColor = '#fff';
    fontColor = '#eab308';
    borderColor = '#eab308';
  } else {
    backgroundColor = '#fff';
    fontColor = '#ccc';
    borderColor = '#ccc';
  }
  if (error) {
    backgroundColor = '#fff';
    fontColor = '#dc2626';
    borderColor = '#dc2626';
  }
  return { backgroundColor, fontColor, borderColor, inProgress };
};
